// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2fow0","dragIcon":"SortableItem_dragIcon__1JgUK","disabled":"SortableItem_disabled__2iisL"};